module.exports = __webpack_public_path__ + "37ac8307a68e42b34be86aa89e680c1f.png";